import { render, staticRenderFns } from "./marketadvice.vue?vue&type=template&id=14396525&scoped=true"
import script from "./marketadvice.vue?vue&type=script&lang=js"
export * from "./marketadvice.vue?vue&type=script&lang=js"
import style0 from "./marketadvice.vue?vue&type=style&index=0&id=14396525&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14396525",
  null
  
)

export default component.exports